import { Fragment, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getItemsIds } from '../../../../utils/common'
import {
  Checkbox,
  CHECKBOX_SIZE,
  CheckboxGroupSkeleton,
} from '../../../Checkbox'
import { FormikField, getFormikCheckboxFieldValueProps } from '../../../Formik'
import {
  EXPORT_ZIP_FORM_FIELD_CHATS_FILES,
  EXPORT_ZIP_FORM_FIELD_CHATS_FILES_PRIVATE,
  EXPORT_ZIP_FORM_FIELD_CHATS_FILES_PUBLIC,
  EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY,
  EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY_PRIVATE,
  EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY_PUBLIC,
} from '../RequestExportEmailsFilesChatsModal.constants'

import {
  checkIsChatsTextOnlyPrivate,
  checkIsChild,
  checkIsPrivate,
  fillFormikValuesFromFieldList,
} from './FormFields.utils'

import * as styles from './FormFields.module.css'

function FormFields({ initialValues, loading, options }) {
  const { t } = useTranslation()
  const { resetForm, setFieldValue, values } = useFormikContext()
  const optionsIds = getItemsIds(options, 'field_id')
  const chatsTextOnlyPrivateValue =
    values[EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY_PRIVATE]
  const chatsTextOnlyPublicValue =
    values[EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY_PUBLIC]
  const chatsFilesPrivateValue =
    values[EXPORT_ZIP_FORM_FIELD_CHATS_FILES_PRIVATE]
  const chatsFilesPublicValue = values[EXPORT_ZIP_FORM_FIELD_CHATS_FILES_PUBLIC]

  useEffect(() => {
    resetForm({
      values: {
        ...initialValues,
        ...fillFormikValuesFromFieldList(optionsIds, true),
      },
    })
  }, [initialValues, optionsIds, resetForm])

  useEffect(() => {
    setFieldValue(
      EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY,
      chatsTextOnlyPrivateValue && chatsTextOnlyPublicValue
    )
  }, [chatsTextOnlyPrivateValue, chatsTextOnlyPublicValue, setFieldValue])

  useEffect(() => {
    setFieldValue(
      EXPORT_ZIP_FORM_FIELD_CHATS_FILES,
      chatsFilesPrivateValue && chatsFilesPublicValue
    )
  }, [chatsFilesPrivateValue, chatsFilesPublicValue, setFieldValue])

  function handleToggleChatsTextOnly(value) {
    setFieldValue(EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY_PRIVATE, value)
    setFieldValue(EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY_PUBLIC, value)
  }

  function handleToggleChatsFiles(value) {
    setFieldValue(EXPORT_ZIP_FORM_FIELD_CHATS_FILES_PRIVATE, value)
    setFieldValue(EXPORT_ZIP_FORM_FIELD_CHATS_FILES_PUBLIC, value)
  }

  return loading ? (
    <CheckboxGroupSkeleton />
  ) : (
    <div className={styles.list}>
      {options.map(field => {
        const isChild = checkIsChild(field)
        const isPrivate = checkIsPrivate(field)
        const isChatsTextOnlyPrivate = checkIsChatsTextOnlyPrivate(field)
        const parentFieldProps = isChatsTextOnlyPrivate
          ? {
              label: t('Request.ExportZipChatsTextOnlyKey'),
              name: EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY,
              onChange: handleToggleChatsTextOnly,
            }
          : {
              label: t('Request.ExportZipChatsFilesKey'),
              name: EXPORT_ZIP_FORM_FIELD_CHATS_FILES,
              onChange: handleToggleChatsFiles,
            }

        return (
          <Fragment key={field.field_id}>
            {isPrivate ? (
              <div className={styles.item}>
                <FormikField
                  {...parentFieldProps}
                  Component={Checkbox}
                  Field={Fragment}
                  className={styles.checkbox}
                  getValueProps={getFormikCheckboxFieldValueProps}
                  iconClassName={styles.checkboxIcon}
                  size={CHECKBOX_SIZE.small}
                />
              </div>
            ) : null}

            <div className={isChild ? styles.childItem : styles.item}>
              <FormikField
                Component={Checkbox}
                Field={Fragment}
                className={styles.checkbox}
                getValueProps={getFormikCheckboxFieldValueProps}
                iconClassName={styles.checkboxIcon}
                label={field.caption}
                name={field.field_id}
                size={CHECKBOX_SIZE.small}
              />
            </div>
          </Fragment>
        )
      })}
    </div>
  )
}

export default FormFields
